import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { BorrowerConfirmationApi } from '../../../../../generated/internalApi/api/BorrowerConfirmationApi';
import { ApiService } from '../api.service';
import { SessionService } from '../session/shared/session/session-service/session.service';
import {
  CommonResponse,
  UserConfirmationRequest,
  UserConfirmationResponse,
  UserEmailConfirmationRequest
} from '@app/shared/models';

@Injectable()
export class UserConfirmationService extends ApiService {

  constructor(
    protected sessionService: SessionService,
    private borrowerConfirmationApi: BorrowerConfirmationApi) {

    super(sessionService);
  }

  public confirmUser(request: UserConfirmationRequest): Observable<UserConfirmationResponse> {
    return this.borrowerConfirmationApi.borrowerConfirmationConfirmUser(
      request,
      this.authToken
    )
    .map(response => response.data)
    .catch(err => {
      console.error(err);
      return throwError(err);
    });
  }

  public sendUserConfirmationEmail(request: UserEmailConfirmationRequest): Observable<CommonResponse> {
    return this.borrowerConfirmationApi.borrowerConfirmationSendUserEmailConfirmaiton(
      request,
      this.authToken
    )
    .catch(err => {
      console.error(err);
      return throwError(err);
    });
  }

}
